import { Page } from "../utils/page";

@Page()
class Contacto {
  constructor() {
  }

  init() {
    this.hideLoader()
    this.initForm()
  }

  hideLoader() {
		const loader = (document.getElementById('loader') as HTMLElement).classList
		loader.add('hideLoader')
		setTimeout(() => loader.add('hide'), 1000)
	}
  initForm(){
    const form = document.querySelector('form')
    if(form != null){
      form.addEventListener('submit',(e)=>{
        document.getElementById('loader').classList.remove('hide','hideLoader')
      })
    }
  }
}
